<template>
  <div>
    <Header>
      評価完了
    </Header>
    <div class="withholding-finished">
      <div class="px-3">
        <div class="summary-area text-center">
          <Balloon />
          <p class="text-left text-size-14 text-weight-500 mt-4">
            お疲れ様でした！<br />
            評価はお互いの評価完了後に反映されます<br />
          </p>
        </div>
        <template v-if="isNotYetFavorite && office">
          <div class="small text-weight-500">
            今回のお仕事はいかがでしたか？またお仕事したい場合は、お気に入り登録してお仕事を探しましょう！
          </div>
          <AppButton :block="true" class="mt-3" @click="onClickFavorite"
            >お気に入り登録して仕事を見る
          </AppButton>
        </template>
        <AppButton :to="{ name: 'Salary' }" :block="true" class="mt-3"
          >給与を確認
        </AppButton>
        <AppButtonOutline
          :to="{ name: 'ApplicationsList' }"
          :block="true"
          class="d-block mt-3"
        >
          仕事管理に戻る
        </AppButtonOutline>
        <div class="text-size-14 text-weight-500 mt-4">
          直接事業所に伝えづらいことやカイテクへのご意見は<a
            :href="externalLink.anonymousFeedbackForm"
            class="external-link"
            >こちら</a
          >
        </div>
      </div>
    </div>
    <BlockBack />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { applicationService } from "@/app/services/ApplicationService";
import { favoriteService } from "@/app/services/FavoriteService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import Header from "@/components/organisms/common/Header.vue";
import { FavoriteOffice } from "@/types/office/FavoriteOffice";
import { Office } from "@/types/office/Office";
import { showErrorModal } from "@/utils/showErrorModal";
import { inAppReviewService } from "@/app/services/InAppReviewService";

@Component({
  components: {
    AppButton,
    AppButtonOutline,
    BlockBack,
    Header
  }
})
export default class ApplicationEvaluationFinished extends Vue {
  office: Office | null = null;
  favoriteOffice: FavoriteOffice | null = null;
  externalLink = {
    anonymousFeedbackForm: process.env.VUE_APP_URL_ANONYMOUS_FEEDBACK_FORM
  };

  async created() {
    if (!this.applicationId) {
      return;
    }

    this.$loading.show();
    try {
      const application = await applicationService.fetchApplication(
        this.applicationId
      );
      this.office = application.order.office;
      const {
        results: favoriteOffices
      } = await favoriteService.fetchFavoriteOffices({
        office: this.office!.id,
        limit: 1
      });
      if (favoriteOffices.length) {
        this.favoriteOffice = favoriteOffices[0];
      }
    } catch (e) {
      showErrorModal(this, e as Error);
    } finally {
      this.$loading.hide();
    }
  }

  async mounted() {
    await inAppReviewService.launchInAppReview("EVALUATE_OFFICE");
  }

  get applicationId() {
    const { applicationId } = this.$route.params;
    if (applicationId === null) {
      return null;
    }
    return parseInt(applicationId.toString(), 10);
  }

  get isNotYetFavorite() {
    return this.favoriteOffice === null || !this.favoriteOffice.isFavorite;
  }

  async onClickFavorite() {
    this.$loading.show();
    try {
      if (this.favoriteOffice?.id) {
        await favoriteService.updateFavoriteOffices(this.favoriteOffice.id, {
          office: this.favoriteOffice.office.id,
          isFavorite: true
        });
      } else {
        await favoriteService.createFavoriteOffices({
          office: this.office!.id,
          isFavorite: true
        });
      }
      await this.$router.push({
        name: "SearchByOffice",
        params: { officeId: this.office!.id.toString() || "" }
      });
    } catch (e) {
      showErrorModal(this, e as Error);
    } finally {
      this.$loading.hide();
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-area {
  padding: 40px 0 20px;
}

.external-link {
  color: $blue;
  text-decoration: underline;
}
</style>
